/**
 * Generic entity selection operations go here. Nothing specific to
 * the current notebook session should exist in this file. Instead,
 * use this to deal with raw normalized storage lookup.
 */
import { createSelector } from "reselect";
import { AppState } from "../types";

/** Gets the entities from state. */
const getEntities = (state: AppState) => (state && state.entities) || null;

/** Memoized selector that gets all kernelDrafts in redux. */
export const getKernelDrafts = createSelector(
  [getEntities],
  entities => (entities && entities.kernelDrafts) || []
);
